// extracted by mini-css-extract-plugin
export default {"tenHoursGroupThroughput":"index_tenHoursGroupThroughput__TMqfw","selectedGroups":"index_selectedGroups__Sn9Y1","vs":"index_vs__e6f2C","chartWrapper":"index_chartWrapper__UZg6S"};